import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
// All pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import BoardOfFriends from './pages/BoardOfFriends/BoardOfFriends';
import FriendDetails from './pages/BoardOfFriends/FriendDetails';
import Resources from './pages/Resources/Resources';
import ResourceDetail from './pages/Resources/ResourceDetail';
import ArtisticProgram from './pages/ArtisticProgram/artisticProgram';
import EducationalProgram from './pages/EducationalProgram/educationalProgram';
import AudioDescriptions from './pages/ArtisticProgram/AudioDescriptions';
import Exhibitions from './pages/ArtisticProgram/Exhibitions';
import Laboratories from './pages/EducationalProgram/Laboratories';
import TalksReading from './pages/EducationalProgram/TalksReadings';
import LaboratoryDetails from './pages/EducationalProgram/LaboratoryDetails';
import TalkReadingsDetails from './pages/EducationalProgram/TalkReadingsDetails';
import AudioDescriptionDetails from './pages/ArtisticProgram/audioDescriptionDetails';

import useDocTitle from './utils/useDocTitle';
import ScrollToTop from './components/ScrollToTop';

// Import Language Context
import { LanguageProvider } from './context/LanguageContext';

function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    };

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  useDocTitle('Home');

  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/artistic-program" element={<ArtisticProgram />} />
            <Route path="/artistic-program/audio-descriptions" element={<AudioDescriptions />} />
            <Route path="/resources/audio-description/:programId" element={<AudioDescriptionDetails />} />
            <Route path="/artistic-program/exhibitions" element={<Exhibitions />} />
            <Route path="/educational-program" element={<EducationalProgram />} />
            <Route path="/educational-program/talks-reading" element={<TalksReading />} />
            <Route path="/educational-program/laboratories" element={<Laboratories />} />
            <Route path="/resources/laboratories/:programId" element={<LaboratoryDetails />} />
            <Route path="/resources/talks-reading/:programId" element={<TalkReadingsDetails />} />
            <Route path="/board-of-friends" element={<BoardOfFriends />} />
            <Route path="/board-of-friends/:id" element={<FriendDetails />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:resourceId" element={<ResourceDetail />} />
            <Route path="/contact/" element={<Contact />} />
          </Routes>
        </ScrollToTop>
      </Router>
    </LanguageProvider>
  );
}

export default App;